export default "__VITE_ASSET__lTiurdEI__"